export const getAttachmentPreviewKind = ({ original_filename = '', mime_type = '', attachment_url = '' }) => {
  const mime = mime_type.toLowerCase()
  if (mime.startsWith('image/')) return 'image'
  if (mime === 'application/pdf') return 'pdf'

  const name = (original_filename || attachment_url).toLowerCase()
  if (/\.(jpe?g|png|gif|webp|bmp)$/i.test(name)) return 'image'
  if (/\.pdf$/i.test(name)) return 'pdf'

  return 'download'
}
